import React from "react";
import "./submitButton.css";
import SimpleButtonWrapper from "../simpleButtonWrapper/simpleButtonWrapper";

const SubmitButton = (props) => {
  return (
    <SimpleButtonWrapper
      position={props.position}
      lastButton={props.lastButton}
    >
      <input
        className={props.classname ? props.classname : "btn"}
        type="submit"
        disabled={props.disabled}
        onClick={props.disabled ? null : props.function}
        value={props.title}
        style={props.styles ? props.styles : null}
      />
    </SimpleButtonWrapper>
  );
};

export default SubmitButton;
